/**
 * Created by pmnia on 7/1/15.
 */
//angular = require('angular');
require('./core.module.js');
require('./bootstrap.dialog.js');
require('./config.js');
require('./constants.js');
require('./emit.services.js');
require('./socket.services.js');
require('./query.service.js');
require('./core.route.js');
require('./base.factory.js');
require('./routerTransition.services.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/core.require.js
 ** module id = 99
 ** module chunks = 0
 **/